// This allows us to load Angular components on legacy server-side pages.
// This mostly import the main AppModule and disable the Angular Router to
// redirect all navigations to the server side
import { APP_BASE_HREF } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { RouterModule, ROUTES } from '@angular/router';
import { DISABLE_ERROR_TRACKING } from '@freelancer/tracking';
import { AppCommonModule } from '../app/app-common.module';
import { CompatRedirectGuard } from './compat-redirect-guard.service';
import { CompatComponent } from './compat.component';
import { components } from './components';

@Component({
  template: `
    <!-- this is empty -->
  `,
})
export class EmptyComponent {}

// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
@NgModule({
  imports: [
    AppCommonModule,
    RouterModule.forRoot([
      {
        path: '**',
        component: EmptyComponent,
        canActivate: [CompatRedirectGuard],
      },
    ]),
  ],
  declarations: [EmptyComponent, CompatComponent],
  providers: [
    CompatRedirectGuard,
    { provide: APP_BASE_HREF, useValue: '/' },
    // This is a hack to make the CLI code splitting and ngc lazy module
    // analysis and compilation work, pending proper fix in
    // https://github.com/angular/angular-cli/issues/4541
    { provide: ROUTES, useValue: components, multi: true },
    { provide: DISABLE_ERROR_TRACKING, useValue: true },
  ],
  bootstrap: [CompatComponent],
})
export class CompatModule {}
